import { ChassisDamageTypes, ContainerDamageTypes } from "types";
import { DamageOption } from "types/damage/damage-types";
import fetchWithRetry from './fetch-retry';

const BASE_URL = new URL('/api/damage-options', window.location.origin);

export const getDamageOptionList = async (locationId?: number): Promise<DamageOption[]> =>
    await fetchWithRetry<DamageOption[]>(
        !!locationId ? `/api/damage-types?locationId=${locationId}` : '/api/damage-types',
        { method: 'GET' },
        []
    );

export const saveDamageOption = async (damageOption: DamageOption, locationId?: number): Promise<DamageOption> => {
    const response = await fetch(
        !!locationId ? `/api/damage-types?locationId=${locationId}` : '/api/damage-types',
        {
            method: 'POST',
            body: JSON.stringify(damageOption),
            headers: new Headers({
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            })
        });
    return response.json();
}

export const updateDamageOption = async (damageOption: DamageOption): Promise<DamageOption | undefined> =>
    await fetchWithRetry<DamageOption | undefined>('/api/damage-types', { method: 'PUT', body: JSON.stringify(damageOption) }, undefined);

export const deleteDamageOption = async (id: number): Promise<void> =>
    await fetchWithRetry<void>(`/api/damage-types/${id}`, { method: 'DELETE' }, undefined);

export const getContainerDamage = async (locationId?: number): Promise<ContainerDamageTypes> => (
    await fetch(
        !!locationId ? `/api/damage-types/options/container?locationId=${locationId}` : '/api/damage-types/options/container',
        {
            method: 'GET',
            headers: new Headers({
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            })
        })
).json();

export const getChassisDamage = async (locationId?: number): Promise<ChassisDamageTypes> => (
    await fetch(
        !!locationId ? `/api/damage-types/options/chassis?locationId=${locationId}` : '/api/damage-types/options/chassis',
        {
            method: 'GET',
            headers: new Headers({
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            })
        })
).json();

export const getGensetDamage = async (locationId?: number): Promise<string[]> => (
    await fetch(
        !!locationId ? `/api/damage-types/options/genset?locationId=${locationId}` : '/api/damage-types/options/genset',
        {
            method: 'GET',
            headers: new Headers({
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            })
        })
).json();